import React from 'react';

import './createCostCenter.scss'
import '../Homepage/Homepage.scss'

import { useLocation } from 'react-router-dom';

import {SystemIcon} from '@workday/canvas-kit-react/icon';
import {setupIcon} from '@workday/canvas-system-icons-web';

import ContentTable from './components/contentTable/contentTable';
import ContentTableTwo from './components/contentTable2/contentTable2';
import { reorganizations, findOption } from '../../data/organizations';

const CreateCostCenter = (props) => {
    const { search } = useLocation();
    const parameters = new URLSearchParams(search);
    const reorganization = findOption(reorganizations, parameters.get('reorganization'))

    return (
        <div className='createCostCenter'>
            <div className='bannerText'>
                <h2>Create Cost Center</h2>
                <div className='icons'>
                    <SystemIcon
                        className='setupIcon'
                        icon={setupIcon}
                        fill={"#e8ebed"}
                    />
                </div>
            </div>
            <div className='content'>
                <ContentTable reorganization={reorganization}/>
            </div>
            <div className='content2'>
                <ContentTableTwo/>
            </div>
            <div className='buttons'>
                <a href='/virtualCareerCenter'><button className='ok'>OK</button></a>
                <a href='/'><button className='cancel'>Cancel</button></a>
            </div>
        </div>
    )
}

export default CreateCostCenter;
